const getters = {
  getObjUsuario: (state) => state.obj_usuario,
};

export default getters;